export const defaultRemoteWatcherHeaders: { [key: string]: string } = {
    "Content-Type": "application/json",
    "Accept": "application/json"
};

export const defaultRemoteWatcherRequestTimeoutMS = 3000;